import { Link } from 'gatsby'
import styled from 'styled-components'

export const HeadingText = styled.h2`
  font-weight: 700;
  color: #3a3a3a;
  line-height: 1.08;
  letter-spacing: -0.035rem;
`

export const ParagraphText = styled.p`
  font-size: 21px;
  font-weight: 500;
  color: #3a3a3a;
`

export const StatRowsWrapper = styled.div`
  margin: 0 auto;
  max-width: 1100px;
  padding: 0 1.8rem;
  position: relative;
  box-sizing: border-box;
  .floating-img {
    position: absolute;
    @media only screen and (max-width: 1014px) {
      display: none;
    }
  }
  .left {
    top: 150px;
    left: -350px;
  }
  .right {
    right: -250px;
    bottom: 100px;
  }
`

export const Row = styled.div`
  display: flex;
  margin-bottom: 0rem;
  align-items: center;
  justify-content: center;
  color: #3a3a3a;
  z-index: 10;
  position: relative;

  @media only screen and (max-width: 760px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center !important;
  }

  @media only screen and (max-width: 460px) {
    padding: 0 1.8rem;
  }

  .stat {
    font-family: Arial !important;
    font-size: 260px;
    font-weight: 700;
    line-height: 1.3;
    margin-right: 2rem;
    justify-content: flex-end;
    align-items: flex-start;
    display: flex;
    width: 50%;
    letter-spacing: -0.035rem;
    text-align: right;
    @media only screen and (max-width: 1120px) {
      font-size: 180px;
    }
    @media only screen and (max-width: 760px) {
      text-align: center;
      margin-right: 0;
      justify-content: center;
      width: 100%;
    }
    @media only screen and (max-width: 460px) {
      font-size: 120px;
    }
  }
  .para {
    width: 50%;
    margin-bottom: 1.2rem;
    @media only screen and (max-width: 760px) {
      width: 100%;
    }
    > h2 {
      margin-bottom: 1rem;
      font-weight: 700 !important;
      font-size: 48px;
      @media only screen and (max-width: 1120px) {
        font-size: 32px;
      }
    }
    > p {
      font-size: 18px;
      max-width: 350px;
      @media only screen and (max-width: 760px) {
        margin: 0 auto;
      }
    }
  }
`

export const ImageSection = styled.div`
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  margin-bottom: 5rem;
  .left,
  .right {
    @media only screen and (max-width: 600px) {
      display: none;
    }
  }
  .center {
    margin: 0 9rem 0 6rem;
    display: flex;
    box-sizing: border-box;
    flex-direction: column;
    align-items: flex-end;

    @media only screen and (max-width: 600px) {
      margin: 0 1.8rem;
      align-items: center;
      justify-content: center;
      > div {
        min-width: auto;
      }
    }
  }
`

export const CaptionedImage = styled.div`
  max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : 'auto')};
  min-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : 'auto')};
  width: 100%;
  > div {
    box-shadow: 0 7px 11px 0 rgba(0, 0, 0, 0.1);
  }

  > p {
    margin-top: 20px;
    color: #515151;
    font-size: 18px;
    font-weight: 500;
  }
`

export const Profile = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 2.8rem;
  > p {
    margin-left: 24px;
    color: #38175b;
    font-weight: 700;
    font-size: 20px;
  }
`

export const HeroQuoteWrapper = styled.div`
  position: relative;
  min-height: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2.4rem;
`

export const QuoteImageContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 5%;
`

export const Separator = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: 20px;
  text-align: center;
  padding: 0 1.8rem;
  .line {
    width: 1px;
    height: 93px;
    background-color: #adadad;
  }
  p {
    color: #7b7b7b;
    margin: 18px 0 28px;
  }
  span {
    color: #3a3a3a;
  }
  @media only screen and (max-width: 500px) {
    margin-top: -15px;
  }
`

export const ArrowLink = styled(Link)`
  color: ${({ theme }) => theme.colors.secondary};
  font-size: 20px;
  font-weight: 500;
  cursor: pointer;
  > div {
    margin-top: 19px;
  }
  svg {
    margin: 0 0 -2px 10px;
  }
  &:hover {
    * {
      filter: brightness(1.2);
    }
  }
`

export const Last = styled.div`
  width: 100%;
  margin: 0 0 3.8rem;
  display: flex;
  justify-content: center;
  > div {
    min-width: 1845px;
  }
  @media only screen and (max-width: 1166px) {
    > div {
      min-width: auto;
      max-width: 1166px;
      width: 100%;
      height: 520px;
    }
  }
  @media only screen and (max-width: 500px) {
    > div {
      max-width: 360px !important;
      min-width: auto;
      width: 100%;
    }
  }
`
